// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"switcher-module--wrapper--92Ksc","op1":"switcher-module--op1--3SvVK","op2":"switcher-module--op2--gNgOv","selected":"switcher-module--selected--1RIuY"};